module.exports = __webpack_public_path__ + "img/5_c-title.46321298.gif";